import "./SectionTitle.css";

const SectionTitle = ({ title, redtext, subtitle, className = "" }) => {
  return (
    <div className={`common-title ${className}`}>
      {title && <h2 className="title">{title}</h2>}
      {subtitle && (
        <p className="subtitle">
          {subtitle}
          <span>{redtext}</span>
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
